export const IS_HTTP_LINK_REGEX =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
export const IS_COLOR_CODE_REGEX = /^#(?:[0-9a-fA-F]{3}){1,2}$/
export const HASHTAG_REGEX = /#([ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9|\-_]+)/g
export const INSTAGRAM_ID_REGEX = /@([0-9|a-z|A-Z\d-_.]+)/
export const INSTAGRAM_ID_REGEX_ALL = /@([0-9|a-z|A-Z\d-_.]+)/g
export const SLUG_REGEX = /^[a-z0-9_.-]{1,30}$/
export const KAKAO_PLACE_LINK_REGEX = /https:\/\/place\.map\.kakao\.com\/[0-9]+$/
export const SLUG_REGEX_BY_CHATGPT = /^[a-zA-Z0-9]+(?:[_\-\.][a-zA-Z0-9]+)*$/
